import Dialog, { DialogButtonRow, DialogCancelButton, DialogDestructiveButton } from './Dialog';
import { clearAccessToken } from '../services/authStorage';
import { logout } from '../store/slices/authSlice';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { PATH } from '../constants/routes';

const LogoutConfirmationDialog = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    onClose();
    clearAccessToken();
    dispatch(logout());
    navigate(PATH.SIGN_IN);
  };

  return (
    <Dialog
      open={open}
      closable={false}
      onClose={onClose}
      title="ÊTES-VOUS SÛR DE VOULOIR VOUS DÉCONNECTER ?"
      slotProps={{
        title: {
          sx: {
            marginBottom: '40px',
            textAlign: 'center',
          },
        },
      }}
      PaperProps={{ sx: { width: 400 } }}
    >
      <DialogButtonRow sx={{ gap: 1 }}>
        <DialogCancelButton variant="contained" onClick={onClose}>
          ANNULER
        </DialogCancelButton>
        <DialogDestructiveButton variant="contained" onClick={handleLogout}>
          DÉCONNECTER
        </DialogDestructiveButton>
      </DialogButtonRow>
    </Dialog>
  );
};

export default LogoutConfirmationDialog;
